import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HgBlogsComponent } from './hg-blogs/hg-blogs.component';
import { BlogArticleComponent } from './blog-article/blog-article.component';
import { Error400Component } from '../home-main/solution/residential/400error.component';

const routes: Routes = [
  { path: 'blog',  component: HgBlogsComponent},
  { path: 'blog/article',  component: BlogArticleComponent},
  { path: 'blog/:number',  component: BlogArticleComponent},
  { path: '**', component: Error400Component}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HgBlogRoutingModule { }
